import { Button } from '@/components/ui/button';
import { Trash } from '@phosphor-icons/react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export const PendingPaymentsTable = ({ payments, onUpdate }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const handleDelete = async (payment) => {
    try {
      await axios.delete(`${API}/pending-payments`, {
        params: {
          date: payment.date,
          description: payment.description
        }
      });
      toast.success('Pending payment removed');
      onUpdate();
    } catch (error) {
      toast.error('Failed to remove payment');
    }
  };

  if (payments.length === 0) {
    return (
      <div className="text-center py-12 text-[#999990]" data-testid="no-pending-payments">
        No pending payments
      </div>
    );
  }

  return (
    <div className="overflow-x-auto" data-testid="pending-payments-table">
      <table className="w-full">
        <thead>
          <tr className="border-b border-[#E5E5E0] text-left">
            <th className="py-3 px-3 text-sm font-semibold text-[#666660]">Date</th>
            <th className="py-3 px-3 text-sm font-semibold text-[#666660]">Description</th>
            <th className="py-3 px-3 text-sm font-semibold text-[#666660] text-right">Amount</th>
            <th className="py-3 px-3 text-sm font-semibold text-[#666660]">Remarks</th>
            <th className="py-3 px-3 text-sm font-semibold text-[#666660] text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment, index) => (
            <tr 
              key={payment.id || `${payment.date}-${payment.description}-${index}`} 
              className="border-b border-[#E5E5E0] table-row"
              data-testid={`pending-payment-row-${index}`}
            >
              <td className="py-3 px-3 text-sm date-text text-[#111110]">{payment.date}</td>
              <td className="py-3 px-3 text-sm text-[#111110]">{payment.description}</td>
              <td className="py-3 px-3 text-sm text-right currency font-medium text-[#D97706]">
                {formatCurrency(payment.amount)}
              </td>
              <td className="py-3 px-3 text-sm text-[#666660]">{payment.remarks || '-'}</td>
              <td className="py-3 px-3 text-center">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleDelete(payment)}
                  className="rounded-none hover:bg-[#E53935]/10 hover:text-[#E53935]"
                  data-testid={`delete-pending-${index}`}
                >
                  <Trash size={16} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PendingPaymentsTable;
